export default {
  "en": {
    "installment": {
      "actions": {
        "closeAllRows": "Close all rows",
        "deleteCount": "You are about to delete {count} installment. Are you sure? | You are about to delete {count} installments. Are you sure?",
        "delete_installments": "Delete installment | Delete installments",
        "edit": "Edit",
        "newInstallment": "New Installment Term",
        "openAllRows": "Open all rows",
        "publish": "Publish",
        "publishCustomer": "Publish...",
        "save": "Update",
        "unpublish": "Unpublish",
        "updateStatus": "Update status",
        "uploadInvoice": "Upload invoice"
      },
      "attributes": {
        "amount": "Amount",
        "customer": "Customer",
        "due_date": "Deadline",
        "paid_at": "Paid at",
        "status_deadline": "Status",
        "unit": "Unit"
      },
      "edit_actions": {
        "edit_amount": "Amounts",
        "edit_deadline": "Deadline",
        "edit_description": "Description",
        "edit_status": "Status"
      },
      "labels": {
        "changeStatusRequested": "Change Installments from status 'Draft' to 'Requested'",
        "changeVisibility": "Change visibility...",
        "change_amounts": "Change amounts",
        "countEdit": "Edit installment for 1 unit | Edit installment for {count} units",
        "created_at": "Created {created_at}",
        "deleteExplanation": "All installments and invoices will be permanently removed from the platform.",
        "deleteExplanationGroup": "Because you want to remove all installments in this installment group, the installment group will be removed as well.",
        "details": "Details",
        "editDueDate": "Edit deadline",
        "editInstallmentTerm": "Edit installment",
        "giveNewAmount": "Give in new amount",
        "goToUnitInstallments": "Unit Installments",
        "invoices": "1 invoice | {count} invoices",
        "noDeadline": "No deadline",
        "notPublished": "Not published",
        "paid": "Paid",
        "published": "Published",
        "publishedCustomer": "Published for customer",
        "publishingForCustomers": "Publishing installments for the customer. Are you sure?",
        "setDueDate": "Set deadline",
        "statusExplained": "What does each installment status mean?",
        "status_deadline": "Status",
        "statuses": {
          "draft": "Draft",
          "expected": "Expected",
          "overdue": "Overdue",
          "paid": "Paid",
          "requested": "Requested"
        },
        "toBePaid": "To be paid",
        "total": "Total",
        "unitInstallmentsWillBeShownHere": "Unit installments will be shown here",
        "unpublishingForCustomers": "Unpublishing installments for the customer. Are you sure?",
        "updateStatusCount": "Update status for 1 installment | Update status for {count} installments",
        "uploadInvoiceCount": "Upload invoice for 1 installment | Upload invoice for {count} installments",
        "uploadInvoiceUnit": "Upload invoice to {unit_name}",
        "vat": "VAT",
        "vat_with_percentage": "{percentage}% VAT",
        "view_list": "List"
      },
      "legend": {
        "installmentDraft": "Draft installment",
        "installmentDraftAfterDueDate": "Draft installment",
        "installmentExpired": "Deadline expired",
        "installmentPaid": "Installment already paid",
        "installmentPaidAfterDue": "Installment paid after deadline",
        "installmentRequested": "Installment requested"
      },
      "placeholders": {
        "customers": {
          "documents": {
            "subtitle": "All installment documents will be shown here.",
            "title": "No documents yet!"
          },
          "new": {
            "subtitle": "New installments will come soon!"
          }
        }
      },
      "sort_options": {
        "due_date": "Deadline",
        "group_name": "Name",
        "status": "Status"
      },
      "validation": {
        "needNumber": "Need a number (e.g. 8400.5)"
      }
    }
  }
}